'use client';
import {
  useFormContext,
  useController,
  UseControllerProps
} from 'react-hook-form';
import { BlocksSelectEvent } from '@blocks-web-components/events/blocks-select';
export const useDropdownController = (
  props: UseControllerProps,
  callback?: (e: BlocksSelectEvent) => void
) => {
  const { control, setValue } = useFormContext();
  const { field, fieldState, ...rest } = useController({ control, ...props });
  const onBlSelect = (e: BlocksSelectEvent): void => {
    setValue(props.name, e.detail.value);
    callback?.(e);
  };
  const isError = !!fieldState.error;
  const fieldNote = fieldState.error?.message;
  return {
    dropdownField: { ...field, onBlSelect, fieldNote, isError },
    field,
    fieldState,
    ...rest
  };
};
